module.exports = __webpack_public_path__ + "img/play-button.4cc3ccdd.svg";